export const getRowsEditSnapshot = (rows) => JSON.stringify(
  (rows || [])
    .map(row => ({
      id: String(row.master_provider_id || ''),
      bo_turnover_amount: String(row.bo_turnover_amount ?? ''),
      bo_valid_turnover_amount: String(row.bo_valid_turnover_amount ?? ''),
      bo_winlose_amount: String(row.bo_winlose_amount ?? ''),
      provider_winlose_amount: String(row.provider_winlose_amount ?? ''),
      notes: String(row.notes ?? '')
    }))
    .sort((first, second) => first.id.localeCompare(second.id))
);

export const getChangedFinanceRows = (rows, baselineRows) => {
  const baselineById = new Map(baselineRows.map(row => [String(row.master_provider_id), getRowsEditSnapshot([row])]));
  return rows.filter(row => (
    getRowsEditSnapshot([row]) !== baselineById.get(String(row.master_provider_id))
  ));
};

export const acknowledgeSavedFinanceRows = (rows, savedRows) => {
  const savedIds = new Set(savedRows.map(row => String(row.master_provider_id)));
  // Keep edits made while the request was in flight; only acknowledge persistence.
  return rows.map(row => savedIds.has(String(row.master_provider_id)) ? { ...row, has_report: true } : row);
};

export const mergeFinanceRowBaselines = (baselineRows, savedRows) => {
  const baselineById = new Map(baselineRows.map(row => [String(row.master_provider_id), row]));
  savedRows.forEach(row => baselineById.set(String(row.master_provider_id), row));
  return [...baselineById.values()];
};
